import { render, staticRenderFns } from "./MasterContainerTambah.vue?vue&type=template&id=5f5dbb51&scoped=true"
import script from "./MasterContainerTambah.vue?vue&type=script&lang=js"
export * from "./MasterContainerTambah.vue?vue&type=script&lang=js"
import style0 from "./MasterContainerTambah.vue?vue&type=style&index=0&id=5f5dbb51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5dbb51",
  null
  
)

export default component.exports